import { hexToRGBA } from '../utils'
import type { ColorSchemes, IPalette } from './colors'
import { palette } from './colors'

type ColorSchemedOutline = `outline-${ColorSchemes}`

function getColorSchemedOutlines(colors: IPalette) {
  return (
    Object.keys(colors).filter(color => color !== 'grey') as ColorSchemes[]
  ).reduce((acc, color) => {
    acc[`outline-${color}`] = `0 0 0 3px ${hexToRGBA(colors[color].base, 0.5)}`
    return acc
  }, {} as Record<ColorSchemedOutline, string>)
}

const shadows = {
  xs: '0 0 0 1px rgba(237, 237, 247, 1)',
  sm: '0 1px 2px 0 rgba(44, 30, 72, 0.05)',
  default:
    '0 1px 3px 0 rgba(31, 31, 71, 0.1), 0 1px 2px 0 rgba(31, 31, 71, 0.06)',
  base: '0 1px 3px 0 rgba(31, 31, 71, 0.1), 0 1px 2px 0 rgba(31, 31, 71, 0.06)',
  md: '0 4px 6px -1px rgba(31, 31, 71, 0.1), 0 2px 4px -1px rgba(31, 31, 71, 0.06)',
  lg: '0 10px 15px -3px rgba(31, 31, 71, 0.1), 0 4px 6px -2px rgba(31, 31, 71, 0.05)',
  xl: '0 20px 25px -5px rgba(31, 31, 71, 0.1), 0 10px 10px -5px rgba(31, 31, 71, 0.04)',
  '2xl': '0 25px 50px -12px rgba(31, 31, 71, 0.25)',
  outline: '0 0 0 3px rgba(9, 135, 230, 0.6)',
  inner: 'inset 0 2px 4px 0 rgba(31, 31, 71,0.06)',
  none: 'none',
  ...getColorSchemedOutlines(palette)
}

export type IShadows = typeof shadows

export default shadows
